import { gql } from '@apollo/client'

export default gql`
  mutation UpdateOnboardingProfile($preferredName: String!, $userId: uuid!) {
    update_person(
      _set: { name: $preferredName }
      where: { users: { id: { _eq: $userId } } }
    ) {
      affected_rows
      returning {
        users {
          id
          role {
            name
          }
        }
      }
    }
  }
`
